import api from '../baseAPIs/core';
import { toUriEncoded } from '@/utils/url';
import type { StoreType } from '@extTypes/api/customily/user';
import type { AddStoreResult } from './typings';

export const addStore = async (url: string, type: StoreType): Promise<AddStoreResult> =>
    api.post('Users/Stores', { Type: type, Url: url }).then(({ data }) => data);

export const createStoreCheckout = async (store: string): Promise<string> =>
    api.post(`Users/Stores/${toUriEncoded(store)}/Checkout`).then(({ data }) => data);
